import React, { Component , Fragment } from "react";
import { Parallax } from "react-parallax";
import ScrollToTop from 'react-scroll-up';
import { FiCheck, FiChevronUp } from 'react-icons/fi';
import Header from "components/header/Header";
import Footer from "components/footer/Footer";

// import CounterOne from "components/counters/CounterOne";
import Testimonial from "components/Testimonial";
import BlogContent from "components/blog/BlogContent";
import BrandTwo from "components/BrandTwo";
// import ServiceList from "components/service/ServiceList";
import Helmet from "components/common/Helmet";
import Slider from 'react-slick';
import { slideSlick } from 'utils/script';

import {
  sliderImage,
  image2,
  image3,
  image6,
  image7,
  image8, portfolio1, portfolio2, portfolio3
} from 'assets/images';

const SlideList = [
    {
        textPosition: 'text-center',
        category: '',
        title: 'Shows',
        description: 'Transcending Afritainment',
        buttonText: 'Watch Now',
        buttonLink: '/register',
    },
  {
    textPosition: 'text-center',
    category: '',
    title: 'Movies',
    description: 'Transcending Afritainment.',
    buttonText: 'Watch Now',
    buttonLink: '/register'
  }
]


  const PortfolioList = [
    {
        image: portfolio1,
        category: 'Comedy',
        title: 'The Black Mariachi'
    },
    {
        image: portfolio2,
        category: 'Thriller',
        title: 'Boy in Blue Trouser'
    },
    {
        image: portfolio3,
        category: 'Sci-Fi',
        title: 'Next Space Afrika'
    }
]

class Paralax extends Component{

  constructor () {
        super()
        this.state = {
            isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }

    render(){
        const PostList = BlogContent.slice(0 , 3);
        // const ServiceContent = ServiceList.slice(0 , 3);

        const { authUser } = this.props

        return(
            <Fragment>
                <Helmet pageTitle="Home" />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                <div id="home">

                  {/* Start Slider Area   */}
                  <div className="slider-wrapper">
                      {/* Start Single Slide */}
                      <Parallax bgImage={sliderImage} strength={700}>
                        <div className="slider-wrapper color-white">
                          <div className="slider-activation slider-digital-agency">
                            <Slider className="rn-slick-dot dot-light" {...slideSlick}>
                              {SlideList.map((value , index) => (
                                <div className={`slide slide-style-2 fullscreen d-flex align-items-center justify-content-center bg_image ${value.bgImage}`} key={index} data-black-overlay="2">
                                  <div className="container">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className={`inner ${value.textPosition}`}>
                                          {value.category ? <span>{value.category}</span> : ''}
                                          {value.title ? <h1 className="title">{value.title}</h1> : ''}
                                          {value.description ? <p className="description">{value.description}</p> : ''}
                                          {value.buttonText ? <div className="slide-btn"><a className="rn-button-style--2 btn-primary-color" href={authUser ? '/' : `/register`}>{value.buttonText}</a></div> : ''}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </Slider>
                          </div>
                        </div>
                      </Parallax>
                  </div>
                  {/* End Slider Area   */}

                  {/* Start Service Area  */}
                  {/* <Parallax className="rn-paralax-service" bgImage={image1} strength={1000}>
                      <div className="service-area ptb--120">
                          <div className="container">
                              <div className="row align-items-center">
                                  <div className="col-lg-12">
                                      <div className="section-title service-style--2 text-center mb--30 mb_sm--0">
                                          <h2>Our Service</h2>
                                          <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                      </div>
                                  </div>
                              </div>
                              <ServiceList item="6" column="col-lg-4 col-md-6 col-sm-6 col-12" />
                          </div>
                      </div>
                  </Parallax> */}
                  {/* End Service Area  */}

                  {/* Start Service Area  */}
                  <Parallax className="rn-paralax-portfolio"  bgImage={image2} strength={500} >
                      <div className="portfolio-area ptb--120" data-black-overlay="6">
                          <div className="container">
                              <div className="row">
                                  <div className="col-lg-12">
                                      <div className="section-title service-style--2 text-center mb--30 mb_sm--0">
                                          <h2>Our Content</h2>
                                          <p>Watch the best of Afritainment (movies and shows) anytime, anywhere.</p>
                                      </div>
                                  </div>
                              </div>
                              <div className="row">
                                  {/* Start Single Portfolio  */}
                                  {PortfolioList.map((value , index) => (
                                      <div className="col-lg-4 col-md-6 col-sm-6 col-12 mt--40" key={index}>
                                          <div className="portfolio">
                                              <div className="thumbnail-inner">
                                                <img className="w-100" src={value.image} alt="About Images"/>
                                                <div className={`bg-blr-image ${value.image}`}></div>
                                              </div>
                                              <div className="content">
                                                  <div className="inner">
                                                      <p>{value.category}</p>
                                                      <h4><a href={authUser ? '/' : `/register`}>{value.title}</a></h4>
                                                      <div className="portfolio-button">
                                                          <a className="rn-btn" href={authUser ? '/' : `/register`}>Watch Now</a>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  ))}
                                  {/* End Single Portfolio  */}
                              </div>
                          </div>
                      </div>
                  </Parallax>
                  {/* End Service Area  */}


                  {/* Start CounterUp Area */}
                  {!authUser && (<Parallax className="rn-counterup-area rn-paralax-counterup" bgImage={image6} strength={1000} >
                    {/* Start Pricing Tbale Area  */}
                    <div className="rn-pricing-table-area ptb--120" data-black-overlay="6">
                      <div className="container">
                        <div className="row">

                          {/* Start PRicing Table Area  */}
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="rn-pricing">
                              <div className="pricing-table-inner">
                                <div className="pricing-header">
                                  <h4 className="title" style={{ color: "white"}}>Basic</h4>
                                  <div className="pricing">
                                    <span className="price">4.99</span>
                                    <span className="subtitle">USD Per Month</span>
                                  </div>
                                </div>
                                <div className="pricing-body">
                                  <ul className="list-style--1">
                                    <li><FiCheck /> Watch with your device at anytime.</li>
                                    <li><FiCheck /> Videos and shows are available in HD.</li>
                                    <li><FiCheck /> Get the first 14 days on us for free.</li>
                                    <li><FiCheck /> Get generic content recommendations</li>
                                  </ul>
                                </div>
                                <div className="pricing-footer">
                                  <a className="rn-btn" href={authUser ? '/' : `/register`}>Try for Free</a>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* End PRicing Table Area  */}

                          {/* Start PRicing Table Area  */}
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="rn-pricing">
                              <div className="pricing-table-inner">
                                <div className="pricing-header">
                                  <h4 className="title" style={{ color: "white"}}>Premium</h4>
                                  <div className="pricing">
                                    <span className="price">11.99</span>
                                    <span className="subtitle">USD Per Month</span>
                                  </div>
                                </div>
                                <div className="pricing-body">
                                  <ul className="list-style--1">
                                    <li><FiCheck /> Watch via 3 devices at anytime.</li>
                                    <li><FiCheck /> Videos and shows are available in HD.</li>
                                    <li><FiCheck /> Get the first 14 days on us for free.</li>
                                    <li><FiCheck /> Get customised content recommendations</li>
                                  </ul>
                                </div>
                                <div className="pricing-footer">
                                  <a className="rn-btn" href={authUser ? '/' : `/register`}>Try for Free</a>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* End PRicing Table Area  */}

                        </div>
                      </div>
                    </div>
                    {/* End Pricing Tbale Area  */}
                  </Parallax>
                  )}
                  {/* End CounterUp Area */}

                  {/* Start Testimonial Area */}
                  <Parallax className="rn-testimonial-area rn-paralax-testimonial  rn-testimonial-light" bgImage={image7} strength={500} data-black-overlay="5">
                      <div className="testimonial-area ptb--120" data-black-overlay="6">
                          <div className="container">
                              <Testimonial />
                          </div>
                      </div>
                  </Parallax>
                  {/* End Testimonial Area */}

                  {/* Start Blog Area */}
                  <Parallax className="rn-blog-area rn-testimonial-light" bgImage={image8} strength={700} data-black-overlay="7">
                      <div className="blog-area ptb--120" data-black-overlay="6">
                          <div className="container">
                              <div className="row">
                                  <div className="col-lg-12">
                                      <div className="section-title service-style--2 text-center mb--30 mb_sm--0">
                                          <h2>Trending Now</h2>
                                          <p>Read about our most trending shows and topics when it comes to African Entertainment.</p>
                                      </div>
                                  </div>
                              </div>
                              <div className="row">
                                  {PostList.map((value , i ) => (
                                      <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                                          <div className="blog blog-style--1 mb--0 mt--40">
                                              <div className="thumbnail">
                                                  <a href={authUser ? '/' : `/register`}>
                                                      <img className="w-100" src={value.img} alt="Blog Images"/>
                                                  </a>
                                              </div>
                                              <div className="content">
                                                  <p className="blogtype">{value.category}</p>
                                                  <h4 className="title"><a href={authUser ? '/' : `/register`}>{value.title}</a></h4>
                                                  <div className="blog-btn">
                                                      <a className="rn-btn text-white" href={authUser ? '/' : `/register`}>Read More</a>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  ))}
                              </div>
                          </div>
                      </div>

                  </Parallax>
                  {/* End Blog Area */}

                   {/*Start Brand Area*/}
                  <Parallax className="rn-brand-area brand-separation ptb--120" bgImage={image3} strength={1000}>
                      <div className="brand-wrapper">
                          <div className="container">
                              <div className="row">
                                  <div className="col-lg-12">
                                      <BrandTwo />
                                  </div>
                              </div>
                          </div>
                      </div>

                  </Parallax>
                  {/* End Brand Area */}

                  {/* Start Back To Top */}
                  <div className="backto-top">
                      <ScrollToTop showUnder={160}>
                          <FiChevronUp />
                      </ScrollToTop>
                  </div>
                  {/* End Back To Top */}

                </div>

                <Footer />

            </Fragment>
        )
    }
}
export default Paralax;
